import React, { FC, useRef, useState, useEffect } from 'react';
import { currentDay, getFotmattedDateCreated } from 'utils/date';
import { ReactComponent as IconSvg } from './img/icon.svg';
import { addSpaceNumber } from 'utils/addSpaceNumber';
import { BeneficiariesTabBtn } from 'ui/BeneficiariesTabBtn';
import { ReactComponent as IconDone } from './img/iconDone.svg';
import { ReactComponent as IconError } from 'assets/img/error.svg';
import styles from './OrdersEmployedsItem.module.scss';
import { ResponseTabEmployedsOrdersType } from 'redux/Api/employedsWorkSupportApi/type';
import { AppTooltip } from 'ui/AppTooltip';

interface OrdersEmployedsItemPropsType {
  order: ResponseTabEmployedsOrdersType;
}

export const OrdersEmployedsItem = ({ order }: OrdersEmployedsItemPropsType) => {
  const textRef = useRef<HTMLDivElement>(null);
  const [isTextOverflowing, setIsTextOverflowing] = useState(false);

  useEffect(() => {
    const checkTextOverflow = () => {
      if (textRef.current) {
        const textElement = textRef.current.querySelector('p');
        if (textElement) {
          setIsTextOverflowing(textElement.scrollWidth > textElement.clientWidth);
        }
      }
    };

    const timeoutId = setTimeout(checkTextOverflow, 100);
    window.addEventListener('resize', checkTextOverflow);

    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener('resize', checkTextOverflow);
    };
  }, [order.status.text]);

  return (
    <div className={styles.root}>
      <p className={styles.root_text}>
        {order.date_start
          ? currentDay(order.date_start?.split(' ')[0])
          : currentDay(order?.status?.created_at?.split(' ')[0])}
      </p>
      <div>
        <p className={styles.root_text}>{order.order_type}</p>
        <p className={styles.root_subText}>
          {order.is_remote ? 'Удалённая работа' : order.order_address}
        </p>
      </div>
      <p style={{ textAlign: 'end' }}>{addSpaceNumber(order.amount)}</p>

      <div>
        <p className={styles.root_text}>{order?.withdraw_method?.method}</p>
        <p className={styles.root_subText}>{order?.withdraw_method?.number}</p>
      </div>
      <div>
        <p>
          {order.withdraw_status ? (
            <IconDone />
          ) : order.withdraw_status === false ? (
            <IconError />
          ) : (
            ''
          )}
        </p>
      </div>
      <div className={styles.iconTitle}>
        <div style={{ padding: '0 16px' }}>
          <AppTooltip
            label={order.status.text}
            disabled={!isTextOverflowing}
            position='top'
            offset={8}
            arrowPosition='center'>
            <div
              ref={textRef}
              style={{
                width: '100%',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                cursor: 'default',
              }}>
              <BeneficiariesTabBtn
                classNameStyles={styles.statusBlock}
                bg={order.status?.color_bg}
                color={order.status?.color_text}
                title={order.status.text}
              />
            </div>
          </AppTooltip>
        </div>
        <p className={styles.root_subText}>
          <IconSvg /> {getFotmattedDateCreated(order.status?.created_at)}. назад
        </p>
      </div>
    </div>
  );
};
